import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { BrowserWindowRef } from '../../../common/services/window.service2';
import { StorageService } from '../../services/storage.service';
import { environment } from '../../../../environments/environment';
import { WindowService } from '../../services/window.service';
//

@Component({
  selector: 'app-root',
  templateUrl: 'secure.component.html'
})
export class SecureComponent implements OnInit {
  navIsFixed = false;
  selectedItems: Array<string> = [];
  userDetails: any;
  FirstName: string;
  showMenu = false;
  isProduction = environment.production;
  upcomingEvents = '';
  lastUpdate = '';

  constructor(private router: Router,
    private storageService: StorageService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(BrowserWindowRef) private window, private windowService: WindowService) {
      this.userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    this.FirstName = this.userDetails.FirstName ? this.userDetails.FirstName : '';
    }

  ngOnInit() {
    this.setLayoutRootCSS();
    this.selectedItems =  JSON.parse(localStorage.getItem('selectedItems'));

    this.storageService.watchStorage().subscribe((storage: any) => {
      // storageService
      console.log(storage);
      if ( storage.key === 'upcomingevents') {
        this.upcomingEvents = storage.data;
      }

      if ( storage.key === 'lastUpdate') {
        this.lastUpdate = storage.data;
      }
      // this.selectedItems = JSON.parse(data);
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const number = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;

    this.navIsFixed = number > 200;

    // if (number > 0) {
    //   console.log('yesssssssssss');
    //   this.navIsFixed = true;
    // } else if (this.navIsFixed && number < 10) {
    //   this.navIsFixed = false;
    // }
  }

  // set class (main-pages) attribute in html > body
  setLayoutRootCSS() {
    const body = document.getElementsByTagName('body')[0];

    const classList = body.classList;
    while (classList.length > 0) {
      classList.remove(classList.item(0));
    }

    body.classList.add('main-pages');
  }

  signOut() {
    // this.authService.removeToken();
    this.router.navigate(['/home/login']);
  }

  hideMenu(e: Event) {
    console.log('hideMenu');
    this.showMenu = false;
  }

  addToFavorites(e: Event) {

    if (this.windowService.nativeWindow.chrome) {
      this.windowService.nativeWindow.chrome.bookmarks.create({'parentId': this.windowService.nativeWindow.bookmarkBar.id, 'title': 'Extension bookmarks'},
      (newFolder: any) => {
        console.log('added folder:'  + newFolder.title);
    });
    }
  }
}
